<h3>Add new test</h3>

<mat-stepper linear #stepper>
    <mat-step>
        <ng-template matStepLabel>Define Test</ng-template>

        <mat-form-field>
          <mat-label>Choose a test creation option</mat-label>
          <mat-select (selectionChange)="onSelectionTestCreationChange($event)">
            <mat-option value="NEW">Create a new test</mat-option>
            <mat-option *ngFor="let item of testInformation" [value]="item.id">
              {{ item.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        
        <form [formGroup]="testCaseForm" *ngIf="isCreateNewTest">
            <div>
                <mat-form-field subscriptSizing="dynamic">
                <mat-label>ID</mat-label>
                <input matInput formControlName="id" required>
                </mat-form-field>
            </div>
            <div>
                <mat-form-field subscriptSizing="dynamic">
                <mat-label>Title</mat-label>
                <input matInput formControlName="title" required>
                <mat-hint>The name of the Test, it suggests which kind of test is going to be done. (ex. In-vehicle frame spoofing)</mat-hint>
                </mat-form-field>
            </div>
            <div>
                <mat-form-field subscriptSizing="dynamic">
                <mat-label>Summary</mat-label>
                <textarea matInput formControlName="summary" required></textarea>
                <mat-hint>It contains a brief description of the test that shall be inserted</mat-hint>
                </mat-form-field>
            </div>
            <div>
                <mat-form-field subscriptSizing="dynamic">
                <mat-label>Test Objectives</mat-label>
                <textarea matInput formControlName="testObjectives" required></textarea>
                <mat-hint>Description of what is the achievement of that particular test.</mat-hint>
                </mat-form-field>
            </div>
            <div>
                <mat-form-field subscriptSizing="dynamic">
                <mat-label>Examples</mat-label>
                <textarea matInput formControlName="examples"></textarea>
                </mat-form-field>
            </div>
            <div>
              <mat-form-field subscriptSizing="dynamic">
                <mat-label>UN R155 (Annex5 Mapping)</mat-label>
                <mat-select formControlName="subLevelThreatID" required multiple (selectionChange)="onSelectionUNR155Change($event)">
                  <mat-option value="N/A">N/A</mat-option>
                  <mat-option *ngFor="let option of UN_R155_Options" [value]="extractRegulationId(option)" [disabled]="isUNR155NASelected && option !== 'N/A'">
                    {{ option }}
                  </mat-option>
                </mat-select>
                <mat-hint>Which Threat extracted from UNECE R155 Annex 5 is going to cover the selected test.</mat-hint>
              </mat-form-field>
            </div>            
            <div>
              <mat-form-field subscriptSizing="dynamic">
              <mat-label>STRIDE</mat-label>
              <mat-select formControlName="stride" required multiple (selectionChange)="onSelectionStrideChange($event)">
                  <mat-option value="N/A">N/A</mat-option>
                  <mat-option *ngFor="let option of STRIDE_Options" [value]="option" [disabled]="isStrideNASelected && option !== 'N/A'">{{ option }}</mat-option>
              </mat-select>
              <mat-hint>Which Theat of the STRIDE Model is covered by the test. It is a relationship towards STRIDE Node.</mat-hint>
              </mat-form-field>
            </div>
            <div>
              <mat-form-field subscriptSizing="dynamic">
                <mat-label>CIA</mat-label>
                <mat-select formControlName="cia" required multiple (selectionChange)="onSelectionCIAChange($event)">
                  <mat-option value="N/A">N/A</mat-option>
                  <mat-option *ngFor="let option of CIA_Options" [value]="option" [disabled]="isCIANASelected && option !== 'N/A'">
                    {{ option }}
                  </mat-option>
                </mat-select>
                <mat-hint>Which Theat of the CIA Model is covered by the test. It is a relationship towards CIA Node.</mat-hint>
              </mat-form-field>
            </div>
            <div>
                <mat-form-field subscriptSizing="dynamic">
                <mat-label>Test Setup</mat-label>
                <textarea matInput formControlName="testSetup" required></textarea>
                <mat-hint>Steps to follow to build the environment to let the test work.</mat-hint>
                </mat-form-field>
            </div>
            <div>
                <mat-form-field subscriptSizing="dynamic">
                <mat-label>Expected Result (Test successful)</mat-label>
                <textarea matInput formControlName="expectedResult" required></textarea>
                <mat-hint>What we are expecting to see if the test doesn’t find any vulnerability.</mat-hint>
                </mat-form-field>
            </div>
            <div>
                <mat-form-field subscriptSizing="dynamic">
                <mat-label>Claims</mat-label>
                <textarea matInput formControlName="claims" required></textarea>
                <mat-hint>Statement about which could be additional consideration to reach exhaustive results.</mat-hint>
                </mat-form-field>
            </div>
          </form>
          <div>
              <button mat-raised-button type="submit" (click)="onFormSubmit()" [disabled]="(isCreateNewTest && !testCaseForm.valid) || isCreateNewTest == null" matStepperNext>Next</button>
          </div>
    </mat-step>
    <mat-step>
      <ng-template matStepLabel>Define Script</ng-template>
      <form [formGroup]="scriptDescriptorForm">
        <div>
          <mat-form-field subscriptSizing="dynamic">
            <mat-label>Interface</mat-label>
            <mat-select formControlName="interface" required>
              <mat-option *ngFor="let interface of interfaces" [value]="interface">{{interface}}</mat-option>
            </mat-select>
            <mat-hint>Name that describes which kind of assets we are targeting. It could be Network and include ethernet interface and connection or could be software and include more than one library.</mat-hint>
          </mat-form-field>
        </div>
        <div>
          <mat-form-field subscriptSizing="dynamic">
            <mat-label>Target (test variant)</mat-label>
            <mat-select formControlName="target" required>
              <mat-option *ngFor="let target of targets" [value]="target">{{target}}</mat-option>
            </mat-select>
            <mat-hint>Which Threat extracted from UNECE R155 Annex 5 is going to cover the selected test. This field is represented through a relationship between the Test Information Node and TARGETS node</mat-hint>
          </mat-form-field>
        </div>
        <div>
            <mat-form-field subscriptSizing="dynamic">
            <mat-label>Script Name</mat-label>
            <input matInput formControlName="scriptName" required>
            <mat-hint>Version of the script.</mat-hint>
            </mat-form-field>
        </div>
        <div>
            <mat-form-field subscriptSizing="dynamic">
            <mat-label>Script Version</mat-label>
            <input matInput formControlName="version" required>
            <mat-hint>Version of the script.</mat-hint>
            </mat-form-field>
        </div>
        <div>
            <mat-form-field subscriptSizing="dynamic">
            <mat-label>Script Description</mat-label>
            <textarea matInput formControlName="scriptDescription" required></textarea>
            <mat-hint>Field that explains the objective of the script itself.</mat-hint>
            </mat-form-field>
        </div>
      </form>
      <div>
        <button mat-raised-button type="submit" (click)="onFormSubmit()" [disabled]="!(scriptDescriptorForm.valid)" matStepperNext>Next</button>
      </div>
    </mat-step>
    <mat-step>
        <ng-template matStepLabel>Define Dependencies</ng-template>
        <form (ngSubmit)="onDependenciesSubmit()">
          <mat-form-field subscriptSizing="dynamic">
              <mat-label>Select Script</mat-label>
              <mat-select [formControl] = "dependenciesForm" multiple required (selectionChange)="onSelectionDependeciesChange($event)">
                  <mat-option value="No dependencies required" [disabled]="isNoDependeciesDefinedSelected">No dependencies required</mat-option>
                  <mat-option value="No dependencies already defined" [disabled]="isNoDependeciesRequiredSelected">No dependencies already defined</mat-option>
                  <mat-option *ngFor="let dep of dependencies" [value]="dep" [disabled]="isNoDependeciesDefinedSelected || isNoDependeciesRequiredSelected">{{dep}}</mat-option>
              </mat-select>
            </mat-form-field>
            <button mat-button type="submit" matStepperNext>Next</button>
        </form>
    </mat-step>
    <mat-step>
        <ng-template matStepLabel>Upload Test Image</ng-template>
        
        <div>
            <mat-toolbar *ngIf="currentTestFile" class="progress-bar">
              <mat-progress-bar color="accent" [value]="progressTestFile"></mat-progress-bar>
              <span class="progress">{{ progressTestFile }}%</span>
            </mat-toolbar>
          
            <mat-form-field subscriptSizing="dynamic">
              <div>
                <mat-toolbar>
                  <input matInput [value]="fileNameTest" />
          
                  <button
                    mat-flat-button
                    color="primary"
                    [disabled]="currentTestFile && isTestFileUploaded || isTestFileUploading "
                    (click)="uploadTestFile()"
                  >
                    Upload
                  </button>
                </mat-toolbar>
          
                <input
                  type="file"
                  id="fileInput"
                  (change)="selectTestImageFile($event)"
                  name="fileInput"
                />
              </div>
              <mat-hint>< testID >_< scriptName >.tar, the test image</mat-hint>
            </mat-form-field>
          </div>
          
          <div *ngIf="messageTestFile" class="message">
            {{ messageTestFile }}
          </div>


          <div>
            <mat-toolbar *ngIf="currentJsonInputFile" class="progress-bar">
              <mat-progress-bar color="accent" [value]="progressJsonInputFile"></mat-progress-bar>
              <span class="progress">{{ progressJsonInputFile }}%</span>
            </mat-toolbar>
          
            <mat-form-field subscriptSizing="dynamic">
              <div>
                <mat-toolbar>
                  <input matInput [value]="fileNameJsonInputSchema" />
          
                  <button
                    mat-flat-button
                    color="primary"
                    [disabled]="currentJsonInputFile && isJsonInputFileUploaded || isJsonInputFileUploading "
                    (click)="uploadJsonInputFile()"
                  >
                    Upload
                  </button>
                </mat-toolbar>
          
                <input
                  type="file"
                  id="fileInput"
                  (change)="selectJsonInputImageFile($event)"
                  name="fileInput"
                />
              </div>
              <mat-hint>< testID >_< scriptName >_input_schema.json, the schema of the input file consumed by the test image</mat-hint>
            </mat-form-field>
          </div>
          
          <div *ngIf="messageJsonInputFile" class="message">
            {{ messageJsonInputFile }}
          </div>


          <div>
            <mat-toolbar *ngIf="currentJsonOutputSchemaFile" class="progress-bar">
              <mat-progress-bar color="accent" [value]="progressJsonOuputSchemaFile"></mat-progress-bar>
              <span class="progress">{{ progressJsonOuputSchemaFile }}%</span>
            </mat-toolbar>
          
            <mat-form-field subscriptSizing="dynamic">
              <div>
                <mat-toolbar>
                  <input matInput [value]="fileNameJsonOutputSchema" />
          
                  <button
                    mat-flat-button
                    color="primary"
                    [disabled]="currentJsonOutputSchemaFile && isOutputSchemaFileUploaded || isOutputSchemaUploading "
                    (click)="uploadOutputSchemaFile()"
                  >
                    Upload
                  </button>
                </mat-toolbar>
          
                <input
                  type="file"
                  id="fileInput"
                  (change)="selectOutputSchemaImageFile($event)"
                  name="fileInput"
                />
              </div>
              <mat-hint>< testID >_< scriptName >_output_schema.json, the schema of the output file produced by the test image</mat-hint>
            </mat-form-field>
          </div>
          
          <div *ngIf="messageJsonOutputSchemaFile" class="message">
            {{ messageJsonOutputSchemaFile }}
          </div>

          <button mat-button color="primary" (click)="finalSubmit()">Submit</button>

    </mat-step>
</mat-stepper>